import { Model, belongsTo } from 'miragejs'

export default Model.extend({
  schoolSubscription: belongsTo(),
  teacherSubscription: belongsTo(),
})
